import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { getClientMe, clientLogout } from "../api/clientAuthApi";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
  const [clientUser, setClientUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const body = await getClientMe();
      setClientUser(body.clientUser || null);
    } catch {
      setClientUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = useCallback(async () => {
    await clientLogout().catch(() => {});
    setClientUser(null);
  }, []);

  const value = useMemo(
    () => ({
      clientUser,
      loading,
      isAuthenticated: Boolean(clientUser?.clientUserId),
      refresh,
      logout,
    }),
    [clientUser, loading, refresh, logout]
  );

  return (
    <ClientAuthContext.Provider value={value}>{children}</ClientAuthContext.Provider>
  );
}

export function useClientAuth() {
  const ctx = useContext(ClientAuthContext);
  if (!ctx) {
    throw new Error("useClientAuth must be used within ClientAuthProvider");
  }
  return ctx;
}
